<template>
    <div>
        <v-file-input
                v-model="icon"
                label="فایل"
                outlined
                @change="submitFiles"
                accept="image/png, image/jpeg, image/bmp"
                placeholder="فایل موردنظر خود را باگذاری کنید."
                hint="حداکثر حجم هر فایل مورد نظر میتواند 150مگابایت باشد."
                prepend-inner-icon="mdi-paperclip"
                prepend-icon=""
                clearable
                clear-icon="mdi-close-circle-outline"
                dense
                :show-size="150"
                class="mt-1"
        ></v-file-input>
        <v-progress-linear
                v-if="progressPercent!== '' "
                class="mx-auto"
                :value="progressPercent"
                color="indigo"
        >
        </v-progress-linear>
    </div>
</template>

<script>
import {Axios2, Bus} from "../../../main";

export default {
    name: "fileUploader",
    data() {
        return {
            progressPercent: '',
            icon: '',
        }
    },
    methods: {
        submitFiles() {
            if (this.icon === '' || this.icon === null)
                return;

            let formData = new FormData();
            formData.append('file', this.icon);

            Axios2.post('/upload/file', formData, {
                timeout:-1,
                onUploadProgress: (response) => {
                    const {loaded, total} = response;
                    let percent = Math.floor((loaded * 100) / total)
                    this.progressPercent = percent

                }
            }).then((x) => {
                this.$modal.success('موفق!', x.data.message);
                this.progressPercent = '';
                Bus.$emit('getFile', x.data.data);

            }).catch((error) => {
                this.$modal.error('خطا!', error.response.data.errors.file[0])
                this.progressPercent = '';
            });
        }
    }
}
</script>

<style scoped>

</style>